
/**
 *
 * `Footnotes` - subcomponent used to provide footnotes to a component.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { Footnote } from '@owc-utils/Footnotes/FootnotesReducerTypes';
import { FootnotesComponent } from '@owc-packages/Footnotes/src/Footnotes';

export default (ComponentInitializeDispatcher as FootnotesComponent).extend({
  name: 'owc-Footnotes',
  props: {
    footnotesData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    footnotes: function() {
      const footnotesData = this.footnotesData?.footnotes;
      if (!footnotesData) {
        return [];
      }

      return footnotesData.map((footnote: Footnote) => footnote.text);
    },
    isDarkMode: function() {
      return Boolean(this.footnotesData?.darkMode);
    },
  },
  methods: {
    /**
     * Generates the footnote according he number and text provided in datajson
     * @param {number} index
     * @param {string} text
     * @returns {string} Computation of index with text
     *
     * eg.
     * `<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>`
     * turns into
     * `<p>[1] Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>`
     *
     * Example without <p> tag
     * `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua`
     * turns into
     * `[1] Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua`
     */
    generateFootnote(index: number, text: string): string {
      const startingTag = '<p>';
      // We know that RTE commming from AEM always starts with a <p> element, thus,
      // we check if it exists and add the index inside that element.
      if (text.startsWith(startingTag)) {
        return `${startingTag}[${index}] ${text.substring(3)}`;
      }
      // otherwise, we also cover the scenario where there is no <p> element.
      return `[${index}] ${text}`;
    },
  },
});
